import React, { useState } from 'react';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
import { Button } from './ui/Button';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    setIsScrolled(latest > 50);
  });
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Trends',
    href: '#insights'
  }, {
    name: 'Hidden Jobs',
    href: '#hidden'
  }, {
    name: 'Stories',
    href: '#stories'
  }];
  return <motion.nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-sage-50/95 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} data-id="element-332">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-333">
        <a href="#" className="group relative z-50" data-id="element-334">
          <div className="flex flex-col leading-none" data-id="element-335">
            <span className={`font-serif text-[28px] tracking-[0.15em] font-black ${isScrolled ? 'text-ink-900' : 'text-white'}`} data-id="element-336">
              BOARDLINE
            </span>
            <span className={`text-[9px] uppercase tracking-[0.3em] font-medium mt-0.5 ${isScrolled ? 'text-ink-700' : 'text-sage-300'}`} data-id="element-337">
              Executive Advisory
            </span>
          </div>
          <div className="h-[1px] w-0 group-hover:w-full transition-all duration-500 bg-accent-400" data-id="element-338" />
        </a>

        <div className="hidden md:flex items-center space-x-8" data-id="element-339">
          {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm uppercase tracking-widest hover:text-accent-400 transition-colors ${isScrolled ? 'text-ink-900' : 'text-white/90'}`} data-id="element-340">
              {link.name}
            </a>)}
          <Button variant={isScrolled ? 'primary' : 'outline'} size="sm" className={!isScrolled ? 'border-white/40 text-white hover:bg-white hover:text-ink-900 hover:border-white' : ''} onClick={() => {
          document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-341">
            Schedule Consultation
          </Button>
        </div>

        <button className="md:hidden z-50 focus:outline-none" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-342">
          {isMobileMenuOpen ? <X className={isScrolled ? 'text-ink-900' : 'text-white'} data-id="element-343" /> : <Menu className={isScrolled ? 'text-ink-900' : 'text-white'} data-id="element-344" />}
        </button>

        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-0 left-0 w-full h-screen bg-ink-900 flex flex-col items-center justify-center space-y-8 md:hidden" data-id="element-345">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-sage-50 text-xl font-serif tracking-widest hover:text-accent-400 transition-colors" data-id="element-346">
                {link.name}
              </a>)}
            <Button variant="primary" onClick={() => {
          setIsMobileMenuOpen(false);
          document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-347">
              Schedule Consultation
            </Button>
          </motion.div>}
      </div>
    </motion.nav>;
}